import { Component, type ReactNode } from 'react'
import { AlertTriangle } from 'lucide-react'

interface Props { children: ReactNode }
interface State { error: Error | null }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-brand-surface font-body flex items-center justify-center px-6">
          <div className="max-w-md w-full text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-brand-secondary border-4 border-black rounded-block block-shadow-1 flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-white" strokeWidth={2.5} />
            </div>
            <div className="bg-white border-4 border-black rounded-block-lg block-shadow-1 p-8">
              <h1 className="font-heading font-extrabold text-2xl text-black mb-2">Something went wrong</h1>
              <p className="font-body text-black opacity-70 text-sm mb-6">
                An unexpected error occurred. Try refreshing the page.
              </p>
              <button
                onClick={() => window.location.reload()}
                className="inline-block bg-brand-secondary text-white font-label font-extrabold text-sm uppercase tracking-wide px-6 py-3 border-4 border-black rounded-block block-shadow-1 btn-press cursor-pointer"
              >
                Reload Page
              </button>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
